<script>
import { mapGetters } from 'vuex'
import TrailPresentationDialog from './TrailPresentationDialog'

export default {
  name: 'TrailPresentation',

  mounted () {
    const dialogDismissTimestamp = localStorage.getItem('trailDialogDismissTime')
    const currentTimestamp = Math.round((new Date).getTime() / 1000)
    const userCurrentTrail = this.user.settings ? this.user.settings.current_trail : null

    if (!userCurrentTrail && (!dialogDismissTimestamp || (currentTimestamp - dialogDismissTimestamp) >= 3600)) {
      this.$modal.show(TrailPresentationDialog)
    }
  },

  computed: {
    ...mapGetters('user', ['user']),
  },

  render () { },
}
</script>